export const getLocale = () => window.I18n && window.I18n.langEnabled ? window.I18n.lang : 'en';